import $ from "jquery";
import TabCell from "../TabCell";
import {GoingUtils,AssertUtils} from "goingutils";


import {
    _getSplitBar,
    _initSplitBarEvent,
} from "../comJs";
import departPanelUtils from "../components/departCommon";
import GoTabUrl from "../goTabsUrl";

class DepartUserTab extends TabCell {

    constructor(vueObj, goTabs) {
        super();
        this.tabId = GoingUtils.getUUid(10);
        this.tabIdName = "departUser";
        this.tabLabel = "部门人员";

        this.topDataFrom = "departUser";
        this.topDtaFromLabel = "角色";

        this.bottomDataFrom = "user";
        this.bottomDtaFromLabel = "用户";

        this.hasType=vueObj.hasType;
        this.active = false;
        this.downMin = "common";
        this.hasSaveGroup = false;
        this.initFirstData = false;
        this.goTabs = goTabs;
        this.topCellHeight=0.45;
        this.topQueryBarHeight=40;
        this.excludeIds=this.goTabs.excludeIds;
    }

    getLeftCellContent(panelHeight, itemConfig) {
        //缓存其panel的高度
        this.panelHeight = panelHeight;
        this.leftTopCellHeight = parseFloat(panelHeight + "") * this.topCellHeight - this.topQueryBarHeight;
        this.leftBottomCellHeight = parseFloat(panelHeight + "") * 0.55 - 20;
        this.topSpaceHeight = 48;
        let groupCheck = false;
        //获取 是否需要选择全集团的checkBox
        if (AssertUtils.isNotNull(itemConfig)) {
            groupCheck = itemConfig["groupCheck"];
        }
        let userGridHeight = this.leftBottomCellHeight + "px";
        return `${departPanelUtils.getPanelHeader(this, this.leftTopCellHeight + "px", this.leftTopCellHeight - 5 + "px", "请输入部门", this.tabId, groupCheck)} 
            ${_getSplitBar()} 
            <div class="wait-sel-user">
                  <div id="${
            this.tabId
            }_userGrid" style="height: ${userGridHeight};"> 
            </div>
        </div>`;
    }


    getRightCellContent(panelHeight) {
        return departPanelUtils.initRightCellContent(panelHeight, this);
    }

    loadSysDefData() {

    }

    /**
     * 初始化部门树
     */
    initDepartTree() {
        let cellObj = this;
        cellObj.departTreeObj = departPanelUtils._initDepartTree(cellObj);
    }

    //查询待选择的用户
    searchWaitForUser() {
        let params = {};
        let orgTreeId = this.departTreeObj.getSelectedItemId();
        params["realName"] = this.getSearchInputVal();
        //如果选择了全集团 则从全集团中进行查询 如果没有选择全集团则从选择的机构中进行查询
        let selAllAcount = this.getIsSelAllAcount();
        if (selAllAcount) {
            params["accountId"] = "all";
            //查询所有用户 根据输入的用户名称
            this.waitSelGrid.flushGridByUrl({
                url: GoTabUrl.queryAllUser,
                params
            });
        } else {
            let params = {current:1,size:9999}
            this.waitSelGrid.flushGridByUrl({
                url: GoTabUrl.getUserByOrgId(orgTreeId),
                params
            });
        }
    }

    //点击查询 查询机构节点
    searchTreeNode(){
        let params = {};
        params["realName"] = this.getSearchInputVal();
        let ids=  this.departTreeObj.findItemIdByLabel(params["realName"]);
        if(ids!=null){
            this.departTreeObj.selectItem(ids,true);
        }
    }

    /**
     * 账套选择事件
     * @param nodeId
     * @param cellObj
     */
    changeAccountEvent(nodeId, cellObj) {
        if (cellObj.waitSelGrid != null) {
            cellObj.waitSelGrid.clearAll();
        }
        cellObj.initFirstData = true;
        departPanelUtils._loadDepartTree({accountId: nodeId}, cellObj);
    }

    //初始化tabcell的容器控件
    initTabCellCtl() {
        let cellObj = this;
        this.initDepartTree();
        //待选择数据的表格
        this.initAlreadyGrid(this.hasType);
        //初始化账套缺省默认值
        this.initAccountDefVal(this.getLoadFormStorageFlag(), cellObj);
        //设置缺少值
        this.initDefEvent({
            topHeight: 70,
            searchFun: function () {
                cellObj.searchTreeNode();
            },
            //查询右边已选的数据表格
            searchAlSelFun: () => {
                this.searchAlSelGrid();
            }
        });
        let backFun=()=>{
            this.excludeIds&&this.excludeIds.forEach((recordId)=>{
                this.waitSelGrid.deleteRow(recordId);
            });
        };
        //待选数据
        this.initWaitGrid(this.tabId + "_userGrid",backFun,this);
        this.initCtlEvent();
    }



    //初始化控件事件
    initCtlEvent() {
        var tabCellObj = this;
        //初始化分隔栏的事件
        _initSplitBarEvent(tabCellObj);
        this.initIconBtnEvent();
        this.searchAlReadyRecord(this);
    }

    //全集团选择操作
    allCheckBoxClick(flag) {
        //true 表示选中  如果this.departTreeObj.getSelectedItemId存在 则取消选中操作
        if (flag && AssertUtils.isNotEmpty(this.departTreeObj.getSelectedItemId())) {
            this.departTreeObj.clearSelection(this.departTreeObj.getSelectedItemId());
        }
    }

    destructionTab() {
        //销毁表格
        if (this.alreadySelGrid != null && AssertUtils.isFunction(this.alreadySelGrid.destructor)) {
            console.log("-------销alreadySelGrid对象-----");
            this.alreadySelGrid.destructor();
            this.alreadySelGrid = null;
        }
        //销毁账套选择树
        if (this.accountTreeObj != null && AssertUtils.isFunction(this.accountTreeObj.destructor)) {
            this.accountTreeObj.destructor();
            this.accountTreeObj = null;
        }
    }

    //双击删除待选数据时  将以前选中的状态去掉
    removeSelectedRecord(rId, dataFrom) {
        if (dataFrom === "用户") {
            this.waitSelGrid.setRowIsNotSelected(rId);
        } else {
            this.accountTreeObj.setCheck(rId, false);
        }
    }
}

function initDepartUserTab(goTabs, vueObj) {
    let departUserTab = new DepartUserTab(vueObj, goTabs);
    goTabs.addTabToFactory("departUser", departUserTab);
}

export default initDepartUserTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/departUserTab.js